// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__2uyWo","title":"ClientInsurance_title__3BBw7","itemText":"ClientInsurance_itemText__1BX8o"};